var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.593 23.496l-10.996-19a3.002 3.002 0 00-5.193 0v.001l-10.996 19a3 3 0 002.595 4.502h21.994a2.998 2.998 0 002.596-4.503zM15 12a1 1 0 112 0v6a1 1 0 01-2 0v-6zM16 24a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: "#C81212"
  })));
}

export default SvgWarningSolid;